import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

import { EventAdapter } from './EventAdapter';
import { ImageUploadContext } from './ImageEventAdapterTypes';

interface RemoveImageEventAdapterEventData {
  context: ImageUploadContext;
}

export class RemoveImageEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendImageRemovedEvent;

  constructor({ context }: RemoveImageEventAdapterEventData) {
    super();

    try {
      this.eventData = {
        context,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}

function sendImageRemovedEvent(data: RemoveImageEventAdapterEventData) {
  sendTeacherAmplitudeEvent(EventTypes.ImageRemoved, data);
}
